var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWpolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6499 30.6443C19.5071 30.6456 19.3468 30.6456 19.1638 30.6456H10.9141C9.23123 30.6456 8.38853 30.6456 7.74513 30.3178C7.17862 30.0291 6.71837 29.5681 6.42971 29.0015C6.10156 28.3575 6.10156 27.5149 6.10156 25.8287V11.3771C6.10156 9.69089 6.10156 8.84717 6.42971 8.20314C6.71837 7.63663 7.17862 7.17637 7.74513 6.88772C8.38916 6.55957 9.23288 6.55957 10.9191 6.55957H25.3707C27.0569 6.55957 27.8988 6.55957 28.5428 6.88772C29.1093 7.17637 29.5711 7.63663 29.8598 8.20314C30.1876 8.84654 30.1876 9.68924 30.1876 11.3721V19.6183C30.1876 19.8028 30.1875 19.9642 30.1862 20.108M19.6499 30.6443C20.08 30.6404 20.3519 30.6249 20.6116 30.5625C20.9189 30.4888 21.2123 30.3666 21.4817 30.2016C21.7855 30.0154 22.0459 29.7557 22.5666 29.235L28.777 23.0246C29.2977 22.5039 29.5566 22.2435 29.7428 21.9397C29.9079 21.6703 30.03 21.3761 30.1038 21.0689C30.1661 20.8093 30.1821 20.5377 30.1862 20.108M19.6499 30.6443V22.5167C19.6499 21.6736 19.6499 21.2518 19.814 20.9297C19.9584 20.6465 20.1885 20.4164 20.4717 20.272C20.7937 20.108 21.2149 20.108 22.058 20.108H30.1862",
    stroke: "white",
    strokeWidth: 1.72043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpolicies);
export default __webpack_public_path__ + "static/media/Wpolicies.470e4ca0218d21f863db8fd5205f0ad9.svg";
export { ForwardRef as ReactComponent };